// React imports
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

// Generic imports
import axios from 'axios';
import dayjs from 'dayjs';
import _ from 'lodash';
import { formatDisplayDateTime } from '../utils/date.js';
import pluralize from 'pluralize';

// MUI Imports
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

function LocalDBResets(props) {
    const { accesstoken } = useOutletContext();
    const [organizations, setOrganizations] = useState(null);
    const [ lastResets, setLastResets ] = useState(null);
    useEffect(() => {
        (async () => {
            const { data: _organizations } = await axios.get(`/api/organizations?accesstoken=${accesstoken}`);
            setOrganizations(_organizations);

            const _lastResets = {};
            await Promise.all(['rates', 'accounts', 'suppliers', 'opportunities'].map(async (table) => {
                for (let i = 0 ; i < _organizations.length ; i++) {
                    const org = _organizations[i];
                    try {
                        const res = await axios.get(`/api/${table}/${org.id}-reset?organizationId=${org.id}&accesstoken=${accesstoken}`);
                        _lastResets[table] = _lastResets[table] || {};
                        _lastResets[table][org.id] = res.data || { modified: -1 };
                    } catch (e) {
                        _lastResets[table] = _lastResets[table] || {};
                        _lastResets[table][org.id] = { modified: -1 };
                    }
                }
            }));
            setLastResets(_lastResets);
        })();
    }, []);

    if (!organizations) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
        </Box>;
    }

    return <InnerLocalDBResets organizations={organizations} accesstoken={accesstoken} lastResets={lastResets} setLastResets={setLastResets} />;
}

function InnerLocalDBResets(props) {
    const { organizations, accesstoken, lastResets, setLastResets } = props;

    async function scheduleReset({ table, organizationId }) {
        const time = new Date().getTime();
        console.log(table, organizationId);
        setLastResets(lastResets => {
            const l = _.cloneDeep(lastResets);
            l[table][organizationId] = null;
            return l;
        });
        await axios.post(`/api/${table}/schedule-localdb-reset?organizationId=${organizationId}&accesstoken=${accesstoken}`, { [pluralize(table, 1)]: {} });
        setLastResets(lastResets => {
            const l = _.cloneDeep(lastResets);
            l[table][organizationId] = { modified: new Date().getTime() };
            return l;
        });
    }

    return (
        <Box sx={{ m: 2 }}>
            <h1>Local DB Resets</h1>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Organization</TableCell>
                            <TableCell sx={{ width: '200px', textAlign: 'center' }}>Rates</TableCell>
                            <TableCell sx={{ width: '200px', textAlign: 'center' }}>Accounts</TableCell>
                            <TableCell sx={{ width: '200px', textAlign: 'center' }}>Suppliers</TableCell>
                            <TableCell sx={{ width: '200px', textAlign: 'center' }}>Opportunities</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {organizations.map(org => (
                            <TableRow key={org.id}>
                                <TableCell>{org.alias}</TableCell>
                                {['rates', 'accounts', 'suppliers', 'opportunities'].map(table => (
                                    <TableCell key={`${org.id}-${table}`} sx={{ width: '200px' }}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            {!lastResets?.[table]?.[org.id] ? <CircularProgress size={12} /> : null}
                                            {lastResets?.[table]?.[org.id]?.modified === -1 ? 'No Reset' : _.isNumber(lastResets?.[table]?.[org.id]?.modified) ? formatDisplayDateTime(lastResets?.[table]?.[org.id]?.modified) : null}
                                        </Box>
                                        {lastResets?.[table]?.[org.id]?.modified && (
                                            <Box sx={{ textAlign: 'center' }}>
                                                <Button sx={{ margin: 'auto' }} variant='contained' color='primary' onClick={() => scheduleReset({ table, organizationId: org.id })}>
                                                    Schedule Reset
                                                </Button>
                                            </Box>
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default LocalDBResets;